import { Breadcrumbs, Link } from '@mui/material';
import { useNavigate } from '@/hooks';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Typography } from '@/components/atoms';
import { BreadcrumbProps } from './Breadcrumb.props';

export const Breadcrumb = ({ items, ...props }: BreadcrumbProps) => {
  const navigate = useNavigate();

  return (
    <Breadcrumbs separator={<NavigateNextIcon />} {...props}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        if (isLast) {
          return <Typography key={index}>{item.label}</Typography>;
        }

        const handleClick = (e: React.MouseEvent) => {
          e.preventDefault();
          if (item.onClick) {
            item.onClick();
          } else if (item.to) {
            navigate(item.to);
          } else if (item.href) {
            // Fallback to href for backward compatibility
            navigate(item.href);
          }
        };

        return (
          <Link
            key={index}
            href={item.to || item.href || '#'}
            onClick={handleClick}
            sx={{ cursor: 'pointer' }}
          >
            {item.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
